import { useDeviceType } from '@cian/ui-kit';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useToggleState } from '../../../hooks/useToggleState';
import { selectAnalyticsFormId } from '../../../selectors/analytics';
import { getAnalyticsSiteType } from '../../../utils';
import { trackInformModalOpen } from '../tracking';

type TUseInformModal = [boolean, () => void];

export const useInformModal = (): TUseInformModal => {
  const [modalOpened, toggleModalOpened] = useToggleState();
  const deviceType = useDeviceType();
  const siteType = getAnalyticsSiteType(deviceType);
  const analyticsFormId = useSelector(selectAnalyticsFormId);

  useEffect(() => {
    /* istanbul ignore else */ if (modalOpened) {
      trackInformModalOpen(siteType, analyticsFormId);
    }
  }, [analyticsFormId, modalOpened, siteType]);

  return [modalOpened, toggleModalOpened];
};
